import { useSnackbar } from "notistack";
import { useCallback } from "react";

/**
 * Consistent snackbars for CRUD / onboarding (use under SnackbarProvider).
 */
export function useNotify() {
  const { enqueueSnackbar } = useSnackbar();

  return {
    success: useCallback(
      (message, options) =>
        enqueueSnackbar(message, { variant: "success", ...options }),
      [enqueueSnackbar]
    ),
    error: useCallback(
      (message, options) =>
        enqueueSnackbar(message, { variant: "error", ...options }),
      [enqueueSnackbar]
    ),
    info: useCallback(
      (message, options) =>
        enqueueSnackbar(message, { variant: "info", ...options }),
      [enqueueSnackbar]
    ),
  };
}
